import React, { useEffect, useState, useRef, useContext } from 'react';
import Countdown from 'react-countdown';
import Button from '@material-ui/core/Button';
import { base_url } from '../../Api/Api';
import Skltn from './skltnDetails';
import Popup from '../../Common/Popup';
import PulseLoader from "react-spinners/PulseLoader";
import { AppContext } from '../../../layout/AppContext'

const LotteryDetail = (props) => {

    const { contextStore, setContextStore } = useContext(AppContext);
    const [state, setState] = useState({
        data: null,
        loader: true,
        rank: ['اول', 'دوم', 'سوم'],
        days: '0',
        hours: '00',
        minutes: '00',
        canRegister: true,
        statusPopup: false
    })
    const [loader, setLoader] = useState(false)

    const Days = useRef(0);
    const Hours = useRef(0);
    const Minutes = useRef(0);

    useEffect(() => {
        updateData()
    }, [])

    const updateData = () => {
        setState({
            ...state,
            canRegister: !state.canRegister
        })
        window.scrollTo(0, 0)

        base_url.get(`lottery/${props.match.params.id}`)
            .then(response => {
                setState({
                    ...state,
                    data: response.data.lottert,
                    canRegister: response.data.lottert.can_register,
                    statusPopup: false
                })
                setContextStore({
                    ...contextStore,
                    userScore: response.data.lottert.user_score || 0
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                        localStorage.clear()
                        window.location.reload()
                    }
                }
            })
    }

    // Renderer callback with condition
    const timerRender = ({ days, hours, minutes, completed }) => {
        if (Days.current.innerText != undefined &&
            Hours.current.innerText != undefined &&
            Minutes.current.innerText != undefined) {
            Days.current.innerText = days
            Hours.current.innerText = (hours == 0 ? '00' : hours)
            Minutes.current.innerText = (minutes == 0 ? '00' : minutes)
        }
        if (completed) {
            return (
                <>
                    <span>00</span>
                    <span>00</span>
                    <span>0</span>
                </>
            );
        } else {
            // Render a countdown
            return <span>{days}:{hours}:{minutes}</span>;
        }
    };

    const lotteryRegister = () => {
        setLoader(true)
        const Data = {
            'lottery_id': state.data.id
        };

        base_url.post("lottery_register", Data)
            .then(response => {
                setState({
                    ...state,
                    statusPopup: true,
                    verficcationText: 'با موفقیت در قرعه کشی شرکت کردید.'
                })
                setLoader(false)
            })
            .catch(error => {
                if (error.response != undefined) {
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                    }
                    setLoader(false)
                }
            })
    }

    return (
        <React.Fragment>
            {state.data == null ?
                <Skltn />
                :
                <div className={`ItemDetail lottery-detailes ${state.data == null ? '' : state.data.time_secound <= 0 ? 'expire' : ''}`}>
                    <Popup
                        active={state.statusPopup}
                        class="award-popup">
                        <span>{state.verficcationText}</span>
                        <div className="btn-base btn-black btn-sircle">
                            <Button variant="contained"
                                onClick={updateData} >تایید</Button>
                        </div>
                    </Popup>
                    <div className="contain">
                        <div className="awardDetails">
                            <div className="backward">
                                <span onClick={() => props.history.goBack()} >بازگشت <i className="icon-arrow-down-sign-to-navigate-fill"></i></span>
                            </div>
                            <div className="detailBody">
                                <div className="details">
                                    <div className="title">
                                        <span>{state.data == null ? null : state.data.title}</span>
                                    </div>
                                    <h5>جزئیات قرعه کشی</h5>
                                    <p>{state.data == null ? null : state.data.description}</p>
                                    <h5>جوایز برندگان</h5>
                                    {state.data == null ? null :
                                        state.data.awards.length == 0 ?
                                            <span className="no-data">{state.data.show_result}</span>
                                            :
                                            state.data.awards.map((item, index) =>
                                                <React.Fragment>
                                                    <h6> {item.title} :</h6>
                                                    <p>{item.description}</p>
                                                </React.Fragment>
                                            )}
                                </div>
                                <div className="timer">
                                    <div className="grades">
                                        <span>حداقل امتیاز : <b>{state.data == null ? null : state.data.required_score || "100"}</b></span>
                                        <span>امتیاز شما : <b>{state.data == null ? null : state.data.user_score || "100"}</b></span>
                                    </div>
                                    {state.data.register_count == 0 ?
                                        <span className="count-register">شما در این قرعه کشی شرکت نکرده اید</span>
                                        :
                                        <span className="count-register">تعداد دفعات شرکت در این قرعه کشی: {state.data.register_count}</span>
                                    }

                                    <div className="counter">
                                        <span>زمان باقی مانده تا قرعه کشی</span>
                                        <div className="timestamp">
                                            <div className="time">
                                                <span ref={Minutes}>{state.minutes}</span>
                                                <span>دقیقه</span>
                                            </div>
                                            <div className="time">
                                                <span ref={Hours}>{state.hours}</span>
                                                <span>ساعت</span>
                                            </div>
                                            <div className="time">
                                                <span ref={Days} >{state.days}</span>
                                                <span>روز</span>
                                            </div>
                                            <div className="cmpnt-timer">
                                                {state.data == null ?
                                                    null
                                                    :
                                                    <Countdown
                                                        date={Date.now() + (state.data.time_secound * 1000)}
                                                        renderer={timerRender} />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {/* {state.data == null ? null :
                                        state.data.can_register ?
                                            <div className="btn-base btn-black btn-sircle">
                                                <Button
                                                    variant="contained"
                                                    onClick={() => loader ? {} : lotteryRegister()} >
                                                    {loader ?
                                                        <PulseLoader
                                                            color="#fff"
                                                            size={10} />
                                                        :
                                                        'شرکت در قرعه کشی'
                                                    }
                                                </Button>
                                            </div>
                                            :
                                            <div className="btn-base btn-gray">
                                                <Button
                                                    variant="contained">شرکت در قرعه کشی</Button>
                                            </div>
                                    } */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </React.Fragment>
    );
}

export default LotteryDetail;